import { Injectable } from '@angular/core';

import {Subject} from "rxjs";

import {VehicleListItem} from "@handover/view-models/vehicle-list-item";
import {HandoverListItem} from "@handover/view-models/handover-list-item";

@Injectable({
  providedIn: 'root'
})
export class HandoverNotificationsService {

  filterTextChangeSubject$ = new Subject<string>();
  filterStatusChangeSubject$ = new Subject<FilterType>();
  selectedVehicleChanged$ = new Subject<VehicleListItem | undefined>();
  isWorkerStatementVisible$ = new Subject<boolean>();
  selectedHandoverChanged$ = new Subject<HandoverListItem | undefined>();
  handoverImagesLoaded$ = new Subject<boolean>();

  constructor() { }
}

export enum FilterType {
  All = 1,
  Available = 2,
  Given = 3
}
